import Guard from '@/services/middleware'

const Home = () => import('@/views/dash/settings/users/Home.vue')
const Profile = () => import('@/views/dash/settings/users/Profile.vue')
const User = () => import('@/views/dash/settings/users/User.vue')
const HoursAccess = () => import('@/views/dash/settings/users/AccessControl.vue')
const Permission = () => import('@/views/dash/settings/users/PermissionHome.vue')

export default [
    {
        path: '/perfil',
        name: 'my.profile',
        component: Profile,
        meta: { title: 'Meu perfil', permission: 1 }
    },
    {
        path: '/usuarios',
        name: 'users.home',
        component: Home,
        meta: { title: 'Usuários', permission: 2,  module: 'config_user' },
        beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkModuleAccess],
    },
    {
        path: '/usuarios/:id',
        name: 'user.id',
        component: User,
        meta: { title: 'Gerenciar usuário', permission: 2,  module: 'config_user' },
        beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkModuleAccess],
    },
    {
        path: '/usuarios/:id/horarios',
        name: 'user.id.hours',
        component: HoursAccess,
        meta: { title: 'Horário de acesso', permission: 2,  module: 'config_user' },
        beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkModuleAccess],
    },
    {
        path: '/usuarios/:id/permissao',
        name: 'user.id.permission',
        component: Permission,
        meta: { title: 'Gerenciar permissão de acesso', permission: 2,  module: 'config_user'},
        beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkModuleAccess],
    },
]
